module.exports = [{"id":1,"name":"平版間歇式印刷機","color":6,"state":"成捲及切張","spec":"冷燙、二度印刷、正背準位印刷","bgi":"File_001.jpeg"},{"id":2,"name":"凸板印刷機","color":2,"state":"成捲及切張","spec":"遮膠加工","bgi":"roller.jpg"},{"id":3,"name":"數位印刷機","color":4,"state":"切張","spec":"正背準位印刷，可做少量貼紙生產","bgi":"digital.jpg"},{"id":4,"name":"燙金軋型複合機","color":"無","state":"成捲及切張","spec":"燙金、軋型","bgi":"foiling.jpg"},{"id":5,"name":"分條機","color":"無","state":"成捲","spec":"貼紙分條","bgi":"divider.jpg"}]


//////////////////
// WEBPACK FOOTER
// ./src/machines.json
// module id = 17
// module chunks = 0